module.exports = __webpack_public_path__ + "static/img/004城市名片4.c45194d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/004城市名片4.jpg
// module id = n/u6
// module chunks = 0